import builder from '../builder';
import Logout1 from '../../streamline-icons/bold/logout-1.svg';

export default builder('IconLogout1Bold', Logout1);
